module.exports = __webpack_public_path__ + "static/media/Sec-1_Home2_CN.ad5f7337.png";